import Vue from 'vue'
import App from './app/App.vue'
import vuetify from './plugins/vuetify'
import * as VeeValidate from 'vee-validate'
// eslint-disable-next-line camelcase
import { alpha_num, confirmed, numeric, max, max_value, min, min_value, regex, required } from 'vee-validate/dist/rules'
import VueCookies from 'vue-cookies'
import store from './_store'
import { router, i18n } from './_helpers'

Vue.component('validation-provider', VeeValidate.ValidationProvider)
Vue.component('validation-observer', VeeValidate.ValidationObserver)

/*eslint-disable */
VeeValidate.extend('required', { ...required })
VeeValidate.extend('confirmed', { ...confirmed })
VeeValidate.extend('min', { ...min })
VeeValidate.extend('max', { ...max })
VeeValidate.extend('alpha_num', { ...alpha_num })
VeeValidate.extend('numeric', { ...numeric })
VeeValidate.extend('minValue', { ...min_value })
VeeValidate.extend('maxValue', { ...max_value })
VeeValidate.extend('regex', { ...regex })
/* eslint-enable */

Vue.use(VueCookies)
Vue.config.productionTip = false
Vue.use(VeeValidate, { inject: false, events: '' })

export const nedasMixin = {
  created: function () {
    let pageTitle = ''
    if (this.$cookies.get('product_name') && this.$cookies.get('product_name').trim() !== '') {
      pageTitle = this.$cookies.get('product_name')
    }
    document.title = pageTitle
  },
  methods: {
    $translatedErrorMessages: function (errors, name, replacements) {
      if (undefined === replacements) {
        replacements = []
      }
      if (errors && Object.keys(errors).length > 0) {
        for (let [key] of Object.entries(errors)) {
          return this.$t(`error.${name}_${key}`.toString().toLowerCase(), replacements)
        }
      }
      return ''
    },

    $translatedServerSideMessages: function (errors, name, replacements) {
      if (undefined === replacements) {
        replacements = []
      }

      let msg = ''
      if (errors && errors.length > 0) {
        errors.forEach(e => {
          msg = this.$t(`error.${name}_${e.rule}`.toString().toLowerCase(), replacements)
        })
      }
      return msg
    },
    isNumber: function (evt) {
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57 || charCode === 46))) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}

Vue.mixin(nedasMixin)

new Vue({
  i18n,
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
